import { GeoJsonType } from '../../graphql';

export interface Location {
  type: GeoJsonType;
  coordinates: any[];
}
